<template>
	<div class="container">
		<div class="top_title">
			<router-link class="icon_back" :to="{ name: 'H600010' }" tag="span"></router-link>
			<span style="padding-right: 2.4rem">校长回访</span>
		</div>
		<div class="scroll_area" style="overflow-y: auto">
			<div class="weui-cells item" style="border: 0 !important; margin-top: 2.4rem">
				<div class="weui-cell weui-cell_select weui-cell_select-after">
					<div class="weui-cell__bd">
						<p>校区</p>
					</div>
					<div class="weui-cell__ft">
						<select class="weui-select" v-model="I_SCHOOL_VALUE" style="color: #bbb">
							<option value="">请选择</option>
							<option v-for="(item, index) in SCHOOL_LIST" :key="index" :value="item.I_SCHOOL_NO">
								{{ item.I_SCHOOL_NAME }}
							</option>
						</select>
					</div>
				</div>
				<div class="weui-cell weui-cell_select weui-cell_select-after">
					<div class="weui-cell__bd">
						<p>班级</p>
					</div>
					<div class="weui-cell__ft">
						<select class="weui-select" v-model="I_CLASS_VALUE" style="color: #bbb">
							<option value="">请选择</option>
							<option v-for="(item, index) in CLASS_LIST" :key="index" :value="item.I_CLASS_NO">
								{{ item.I_CLASS_NAME }}
							</option>
						</select>
					</div>
				</div>
				<div class="weui-cell weui-cell_select weui-cell_select-after">
					<div class="weui-cell__bd">
						<p>学员</p>
					</div>
					<div class="weui-cell__ft">
						<select class="weui-select" v-model="I_STUDENT_VALUE" style="color: #bbb">
							<option value="">请选择</option>
							<option v-for="(item, index) in STUDENT_LIST" :key="index" :value="item.I_STUDENT_NO">
								{{ item.I_STUDENT_NAME }}
							</option>
						</select>
					</div>
				</div>
				<div class="weui-cell weui-cell_select weui-cell_select-after">
					<div class="weui-cell__bd">
						<p>回访日期</p>
					</div>
					<div class="weui-cell__ft">
						<!--            <el-date-picker
              class="weui-select"
              id="datePicker"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              v-model="dateValue"
              type="date"
              prefix-icon="none"
              :clearable="false"
              :editable="false"
              align="right"
              @change="onChangeDatePicker"
            >
            </el-date-picker> -->
						<span class="weui-select" id="showDatePicker" @click="showDatePicker" style="color: #bbb;padding-right: 1rem;">
							{{dateValue}}
						</span>
					</div>
				</div>
				<div>
					<el-input style="border: 0; outline: none" type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="请输入回访备注"
					 v-model="I_REMARK">
					</el-input>
				</div>
			</div>
			<button class="bottom_btn" @click="commit_ReturnVisit">提交</button>
		</div>
	</div>
</template>

<script>
	import DataRequestFactory from "@/factories/dataRequestFactory.js";
	import weui from "weui.js";
	export default {
		data() {
			return {
				textarea: "",
				I_SCHOOL_NAME: "",
				I_SCHOOL_VALUE: "",
				SCHOOL_LIST: [],
				I_CLASS_NAME: "",
				I_CLASS_VALUE: "",
				CLASS_LIST: [],
				I_REMARK: "",
				dateValue: "请选择",
				STUDENT_LIST: [],
				I_STUDENT_NAME: "",
				I_STUDENT_VALUE: "",
				pickerOptions: {
					disabledDate(time) {
						let curDate = new Date().getTime();
						let three = 90 * 24 * 3600 * 1000;
						let threeMonths = curDate - three;
						return time.getTime() > Date.now() || time.getTime() < threeMonths;
					},
				},
			};
		},
		created() {
			if (this.$router.options.routes[6].name !== 'H600020') {
				location.reload();
			}
		},
		watch: {
			I_SCHOOL_VALUE(val) {
				this.init();
				this.onClickClass();
			},
			I_CLASS_VALUE(val) {
				this.STUDENT_LIST = [];
				this.I_STUDENT_VALUE = "";
				this.onClickStudent();
			},
		},
		methods: {
			//初始化
			init() {
				this.STUDENT_LIST = [];
				this.I_STUDENT_VALUE = "";
				this.CLASS_LIST = [];
				this.I_CLASS_VALUE = "";
				DataRequestFactory.C010010().then((response) => {
					this.SCHOOL_LIST = response.dataList;
				});
			},
			//班级
			onClickClass() {
				if (this.I_SCHOOL_VALUE == "") {
					// weui.topTips('请先选择校区', 1000)
					return;
				}
				let requestParams = {
					I_SCHOOL_NO: this.I_SCHOOL_VALUE,
				};
				let that = this;
				DataRequestFactory.C010011(requestParams).then((response) => {
					that.CLASS_LIST = response.dataList;
				});
			},
			//学员
			onClickStudent() {
				if (this.I_SCHOOL_VALUE == "") {
					// weui.topTips('请先选择校区', 1000)
					return;
				} else if (this.I_CLASS_VALUE == "") {
					// weui.topTips('请先选择班级', 1000)
					return;
				}
				let requestParams = {
					I_SCHOOL_NO: this.I_SCHOOL_VALUE,
					I_CLASS_NO: this.I_CLASS_VALUE,
				};
				let that = this;
				DataRequestFactory.C010012(requestParams).then((response) => {
					that.STUDENT_LIST = response.dataList;
				});
			},
			showDatePicker() {
				let year = new Date().getFullYear()
				let month = new Date().getMonth() + 1
				let day = new Date().getDate()
				let that = this
				weui.datePicker({
					// start: 1990,
					start: new Date().getFullYear() - 1,
					end: new Date(),
					defaultValue: [year, month, day],
					// onChange: function (result) {
					//     console.log(result);
					// },
					onConfirm: function(result) {
						that.dateValue = result[0].value + "-" + result[1].value + "-" + result[2].value
					}
				});
			},
			// onChangeDatePicker(e) {},
			//提交回访记录
			commit_ReturnVisit() {
				// if (this.I_SCHOOL_VALUE == "") {
				// 	weui.topTips('请先选择校区', 1000)
				// 	return;
				// } else if (this.I_CLASS_VALUE == "") {
				// 	weui.topTips('请先选择班级', 1000)
				// 	return;
				// } else if (this.I_STUDENT_VALUE == "") {
				// 	weui.topTips('请先选择学员', 1000)
				// 	return
				// } else if (this.dateValue == "") {
				// 	weui.topTips('请选择回访日期', 1000)
				// 	return
				// } else if (this.I_REMARK == "") {
				// 	console.log(this.I_REMARK.length, this.I_REMARK)
				// 	weui.topTips('请输入回访内容', 1000)
				// 	return
				// }
				let requestParams = {
					I_SCHOOL_NO: this.I_SCHOOL_VALUE,
					I_CLASS_NO: this.I_CLASS_VALUE,
					I_STUDENT_NO: this.I_STUDENT_VALUE,
					I_DATE: this.dateValue,
					I_REMARK: this.I_REMARK,
				};
				DataRequestFactory.I600021(requestParams).then((response) => {
					console.log(response);
					if (response.resultCode == 0) {
						weui.toast("提交成功", 2000);
					}
					this.$router.push("/H600010");
				});
			},
		},
		mounted() {
			var win_h = $(window).height(); //关键代码
			$("body").height(win_h); //关键代码
			this.init();
			//修改日期选择样式
			// if (document.getElementById("datePicker")) {
			// 	let datePicker = document.getElementById("datePicker");
			// 	datePicker.style.border = "0px";
			// 	datePicker.style.padding = "0px";
			// 	datePicker.style.paddingRight = "0";
			// 	datePicker.style.margin = "0px";
			// 	datePicker.style.width = "8.8rem";
			// 	datePicker.style.height = "auto";
			// 	datePicker.style.lineHeight = "auto";
			// 	datePicker.style.textAlign = "right";
			// 	datePicker.style.color = "#bbb";
			// }
			// if (document.getElementsByClassName("weui-cell__ft")) {
			// 	document.getElementsByClassName(
			// 		"weui-cell__ft"
			// 	)[3].children[0].style.width = "auto";
			// }
		},
	};
</script>

<style scoped>
	@import "../assets/css/common.css";
</style>
<style scoped>
	.el-textarea__inner {
		border: 0;
		outline: none;
		padding: 0.8rem;
		width: 100%;
		height: 8rem;
		box-sizing: border-box;
	}

/* 	.el-date-picker__header-label {
		padding: 0.462962rem;
		line-height: 3.009259rem;
	}

	.el-picker-panel__icon-btn {
		font-size: 1.157407rem;
		padding: 0.462962rem;
	} */
</style>



// WEBPACK FOOTER //
// src/pages/H600020.vue